import React from 'react';
import { Sun, Moon } from 'lucide-react';

const ThemeToggle = ({ isDarkMode, toggleTheme, isMobile = false }) => {
  if (isMobile) {
    return (
      <button
        onClick={toggleTheme}
        className={`flex items-center gap-2 p-2 rounded-lg ${
          isDarkMode
            ? "text-brand-logo-purple hover:bg-brand-logo-purple/10"
            : "text-gray-700 hover:bg-gray-100"
        }`}
      >
        {isDarkMode ? <Sun size={18} /> : <Moon size={18} />}
        <span>{isDarkMode ? "Light Mode" : "Dark Mode"}</span>
      </button>
    );
  }
  
  return (
    <div className="flex w-full bg-brand-logo-purple/10 p-1 rounded-full relative border border-brand-logo-purple/20">
      <div 
        className={`absolute top-1 bottom-1 w-1/2 transition-all duration-300 ease-in-out ${
          isDarkMode 
            ? 'translate-x-full bg-brand-logo-purple/30 rounded-full shadow-sm border border-brand-logo-purple/40' 
            : 'translate-x-0 bg-white rounded-full shadow-sm'
        }`}
      />
      
      <button
        onClick={toggleTheme}
        className={`flex items-center justify-center gap-2 py-2 flex-1 rounded-full transition-colors z-10 relative ${
          !isDarkMode
            ? "bg-white text-black"
            : "text-gray-400 hover:text-white"
        }`}
        aria-label="Light mode"
      >
        <Sun size={16} className="transition-opacity duration-300" />
        <span className="text-sm font-medium">Light</span>
      </button>
 
      <button
        onClick={toggleTheme}
        className={`flex items-center justify-center gap-2 py-2 flex-1 rounded-full transition-colors z-10 relative ${
          isDarkMode
            ? "bg-brand-logo-purple/30 text-brand-logo-purple border border-brand-logo-purple/40"
            : "text-gray-500 hover:text-gray-800"
        }`}
        aria-label="Dark mode"
      >
        <Moon size={16} className="transition-opacity duration-300" />
        <span className="text-sm font-medium">Dark</span>
      </button>
    </div>
  );
};

export default ThemeToggle; 